import Cookies from "js-cookie";

export const COMPLETE_PROFILE_TRIGGER_SELECTOR =
  '[data-show-complete-profile="true"]';

export const COMPLETE_PROFILE_PATH = "/members/complete-profile";

const SKIPPED_LOGIN_KEY = "complete_profile_skipped_login";

export const getCurrentLogin = () => Cookies.get("blaize_session") ?? "";

export const isPromptEligibleUser = (loadedLogin: string): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  const currentLogin = getCurrentLogin();

  if (!currentLogin || currentLogin !== loadedLogin) {
    return false;
  }

  const user = window.Sifted?.user;

  if (!user?.is_logged_in) {
    return false;
  }

  return !(user.is_academic_user || user.details?.is_academic_user);
};

export const isPromptSkippedForCurrentLogin = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    return (
      window.localStorage.getItem(SKIPPED_LOGIN_KEY) === getCurrentLogin()
    );
  } catch {
    return false;
  }
};

export const markPromptSkippedForCurrentLogin = (): void => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(SKIPPED_LOGIN_KEY, getCurrentLogin());
  } catch {
    return;
  }
};

export const buildCompleteProfileUrl = (returnTo: string): string =>
  `${COMPLETE_PROFILE_PATH}?prompt=optional&redirectUrl=${encodeURIComponent(returnTo)}`;
